export default {
  formId: 'userForm',
  formField: {
    fullName: {
      name: 'fullName',
      label: 'Nome Completo*',
      requiredErrorMsg: 'Digite um nome completo',
      invalidErrorMsg: 'Nome e sobrenome obrigatório',
      invalidSizeMsg: 'Você excedeu o limite de caracteres',
    },
    email: {
      name: 'email',
      label: 'E-mail*',
      requiredErrorMsg: 'Insira um e-mail',
      invalidErrorMsg: 'Digite um email válido',
    },
    emailContact: {
      name: 'emailContact',
      label: 'E-mail de Contato*',
      requiredErrorMsg: 'Insira um e-mail de contato',
      invalidErrorMsg: 'Digite um email de contato válido',
    },
    registration: {
      name: 'registration',
      label: 'Matricula (opcional)',
    },
    cpf: {
      name: 'cpf',
      label: 'CPF',
    },
    phone1: {
      name: 'phone1',
      label: 'Telefone 1',
    },
    phone2: {
      name: 'phone2',
      label: 'Telefone 2',
    },
    area: {
      name: 'area',
      label: 'Área*',
      requiredErrorMsg: 'Escolha uma área.',
    },
    subArea: {
      name: 'subArea',
      label: 'Sub área(opcional)',
    },
    office: {
      name: 'office',
      label: 'Cargo*',
      requiredErrorMsg: 'Escolha um cargo.',
    },
    manager: {
      name: 'manager',
      label: 'Gestor(opcional)',
    },
    specialNeed: {
      name: 'specialNeed',
      label: 'Possui Necessidades especiais',
    },
    zipCode: {
      name: 'zipCode',
      label: 'CEP',
    },
    street: {
      name: 'street',
      label: 'Logradouro',
    },
    number: {
      name: 'number',
      label: 'Número',
    },
    complement: {
      name: 'complement',
      label: 'Complemento(opcional)',
    },
    district: {
      name: 'district',
      label: 'Bairro',
    },
    city: {
      name: 'city',
      label: 'Cidade',
    },
    state: {
      name: 'state',
      label: 'UF',
    },
    profiles: {
      name: 'profiles',
      label: 'Perfil*',
      requiredErrorMsg: 'Selecione um perfil',
    },
    groups: {
      name: 'groups',
      label: 'Função*',
      requiredErrorMsg: 'Selecione uma função',
    },
  },
};
